const COLOR_MAP = {
  blanco: "#ffffff",
  negro: "#000000",
  rojo: "#d13a30",
};

export const MARCO_SECUENCIA_COLORS = [
  "blanco",
  "negro",
  "rojo",
].map((color) => ({
  id: color,
  name: color.charAt(0).toUpperCase() + color.slice(1),
  swatch: COLOR_MAP[color],
  frameSrc: `/images/frames-marco/marco-secuencia/marco-secuencia-${color}.png`,
}));

export const MARCO_SECUENCIA_CONFIG = {
  id: "marco-secuencia",
  name: "Marco Secuencia",
  canvas: {
    w: 1800,
    h: 560,
  },
  imageBoxes: [
    {
      id: "first",
      x: 104,
      y: 106,
      w: 350,
      h: 350,
    },
    {
      id: "second",
      x: 520,
      y: 106,
      w: 350,
      h: 350,
    },
    {
      id: "third",
      x: 928,
      y: 106,
      w: 350,
      h: 350,
    },
    {
      id: "fourth",
      x: 1346,
      y: 106,
      w: 350,
      h: 350,
    },
  ],
  mobilePhotoBoxes: [
    {
      id: "first",
      label: "Foto 1",
      x: 104,
      y: 106,
      w: 350,
      h: 350,
    },
    {
      id: "second",
      label: "Foto 2",
      x: 520,
      y: 106,
      w: 350,
      h: 350,
    },
    {
      id: "third",
      label: "Foto 3",
      x: 928,
      y: 106,
      w: 350,
      h: 350,
    },
    {
      id: "fourth",
      label: "Foto 4",
      x: 1346,
      y: 106,
      w: 350,
      h: 350,
    },
  ],
  photoBoxes: [
    {
      id: "first",
      label: "Foto 1",
      x: 104,
      y: 104,
      w: 350,
      h: 348,
    },
    {
      id: "second",
      label: "Foto 2",
      x: 520,
      y: 104,
      w: 350,
      h: 348,
    },
    {
      id: "third",
      label: "Foto 3",
      x: 933,
      y: 104,
      w: 350,
      h: 348,
    },
    {
      id: "fourth",
      label: "Foto 4",
      x: 1346,
      y: 104,
      w: 350,
      h: 348,
    },
  ],
};





